import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '@/lib/api'
import { Preloader } from '@/components/Preloader'

/**
 * Ports VacancyController.InfoRedirect and FormRedirect.
 *
 * Both took a plain integer id, encoded it and issued a redirect to the
 * canonical `/Vacancy/{Info,Form}/<encoded>` URL. The encoding key lives on the
 * server, so the id is exchanged there and the result replaces this entry in
 * history — the same 302 the browser used to follow, minus the round trip
 * showing up in the back button.
 */
export function VacancyIdRedirect({ target }: { target: 'Info' | 'Form' }): JSX.Element {
  const { trxVacancyID } = useParams<{ trxVacancyID: string }>()
  const navigate = useNavigate()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false

    void (async () => {
      try {
        const { encoded } = await api.get<{ encoded: string }>(
          `/api/ecareer/vacancy/encode/${encodeURIComponent(trxVacancyID ?? '')}`,
        )
        if (!cancelled) navigate(`/Vacancy/${target}/${encoded}`, { replace: true })
      } catch {
        // HandleDecodeError sent the user back to the listing.
        if (!cancelled) {
          setFailed(true)
          navigate('/Vacancy', { replace: true })
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [trxVacancyID, target, navigate])

  return failed ? <></> : <Preloader />
}
